import {
  DynamicAttributeFieldFragment,
  DynamicAttributeFieldListFragment,
  DynamicAttributeType,
  DynamicAttributeValueInput,
} from "gql/graphql";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import {
  FALSE,
  TRUE,
} from "@/shared/dynamic-attributes/ui/dynamic-attribute-field/dynamic-attribute-field-simple/dynamic-attribute-field-simple-boolean-select-values";

export function transformMetaFieldToAttributeValueInput(
  meta: DynamicAttributeFieldFragment,
): DynamicAttributeValueInput {
  let value;

  switch (meta.__typename) {
    case "SimpleTypeDynamicAttributeDto":
      switch (meta.value?.__typename) {
        case "BooleanDynamicAttributeValueDto":
          value =
            meta.value.booleanValue === true
              ? TRUE
              : meta.value.booleanValue === false
                ? FALSE
                : null;
          break;
        case "DateTimeDynamicAttributeValueDto":
          value = meta.value.dateTimeValue;
          break;
        case "DateDynamicAttributeValueDto":
          value = meta.value.dateValue;
          break;
        case "NumberDynamicAttributeValueDto":
          value = meta.value.numberValue?.toString();
          break;
        case "FloatDynamicAttributeValueDto":
          value = meta.value.floatValue?.toString();
          break;
        case "StringDynamicAttributeValueDto":
          value = meta.value.stringValue;
          break;
        case undefined: // As example filters
          value = null;
          break;
        default:
          throw new Error(`Unsupported attribute value type`);
      }
      break;

    case "EnumTypeDynamicAttributeDto":
      value = meta.enumValueId;
      break;

    case "ReferenceTypeDynamicAttributeDto":
      value = meta.valueId;
      break;
    case "LocalizedValueDynamicAttributeDto":
      value = JSON.stringify(extractLocalizedValue(meta.localizedValue));
      break;
  }

  if (
    meta.__typename === "SimpleTypeDynamicAttributeDto" &&
    meta.type === DynamicAttributeType.Boolean &&
    meta.required &&
    meta.value === null
  ) {
    value = FALSE;
  }

  return {
    attributeCode: meta.attributeCode,
    value,
  };
}

export function transformMetaFieldsToAttributeValueInput(
  meta: DynamicAttributeFieldListFragment,
): DynamicAttributeValueInput[] {
  return [
    ...meta.attributes.map((attribute) => {
      return transformMetaFieldToAttributeValueInput(attribute);
    }),
    ...meta.groups.flatMap((group) => {
      return group.attributes.map((attribute) => {
        return transformMetaFieldToAttributeValueInput(attribute);
      });
    }),
  ];
}
